exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.sticky[data-v-2b623e76]{position:-webkit-sticky;position:sticky;top:64px;background-color:#ff0;font-size:20px;z-index:14;text-align:center;width:84%;margin:auto auto 20px;border-radius:5px}.btn-open_game[data-v-2b623e76]{background-image:linear-gradient(92.88deg,#455eb5 9.16%,#5643cc 43.89%,#673fd7 64.72%);border-radius:5px;color:#fff;cursor:pointer;font-size:16px;padding:0 10px;text-shadow:rgba(0,0,0,.25) 0 3px 8px;transition:all .5s;margin-left:5px}.btn-open_game[data-v-2b623e76]:hover{box-shadow:0 1px 15px rgba(80,63,205,.5);transition-duration:.1s}", ""]);

// exports
